import { render, staticRenderFns } from "./AddMarca.vue?vue&type=template&id=1d2eb458"
import script from "./AddMarca.vue?vue&type=script&lang=js"
export * from "./AddMarca.vue?vue&type=script&lang=js"
import style0 from "./AddMarca.vue?vue&type=style&index=0&id=1d2eb458&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports